import {Dispatch, SetStateAction} from 'react'

import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST} from '../state'
import {getToken} from './token_fetcher'
import {normalizeTaskScheduleReminderList, TaskScheduleReminderDTO} from '../../model/task_schedule_reminder'

export const REQUEST_TASK_SCHEDULE_REMINDER_UPDATE = 'REQUEST_TASK_SCHEDULE_REMINDER_UPDATE'
export const doREQUEST_TASK_SCHEDULE_REMINDER_UPDATE = createDoRequestAction(REQUEST_TASK_SCHEDULE_REMINDER_UPDATE)

export const requestTaskScheduleReminderUpdateActionCreators = {
  doREQUEST_TASK_SCHEDULE_REMINDER_UPDATE,
}

interface Payload {
  payload: {
    requestId: string
    taskScheduleId: string
    reminderList: TaskScheduleReminderDTO[]
  }
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestTaskScheduleReminderUpdate({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestTaskScheduleReminderUpdate')

  payload.reminderList = normalizeTaskScheduleReminderList(payload.reminderList)

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        taskScheduleId: v.string().uuid().exist(),
        reminderList: v
          .array()
          .items(
            v.object({
              secondsBeforeExpiration: v.number().integer().positive().required(),
              title: v.string().required(),
              message: v.string().required(),
            }),
          )
          .required(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SCHEDULE_REMINDER_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const accessToken = yield call(getToken)
  const {taskScheduleId, reminderList} = payload

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/task-schedule-reminder-update`,
    accessToken,
    data: {
      taskScheduleId,
      reminderList,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SCHEDULE_REMINDER_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/task-schedule-reminder-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doMETHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST({taskScheduleId, reminderList: result.payload}))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_SCHEDULE_REMINDER_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* taskScheduleReminderUpdateSaga() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  yield takeEvery(REQUEST_TASK_SCHEDULE_REMINDER_UPDATE as any, requestTaskScheduleReminderUpdate)
}
